<dsy-modal
  title-label="'modal title'"
  subtitle-label="Modal subtitle"
  custom-header
  custom-footer
  z-index=1
  width="650px"
  closes-on-apply
  background-overlay-hidden
  [isOpen]="openModal"
>
  <div slot="header">
    <p class="fs-1">{{title}}</p>
    <div class="row">
      <span class="mr-2 col-11">{{message}}</span>
    </div>
    <div class="row require-password-container" *ngIf="requirePassword">
      <div class="col-12">
        <div class="col-10">
          <dsy-input-with-message *ngIf="passwordResetToDefault" type={{type}} input-status="default" placeholder="Password" id="{{idTitle}}-password" label="Enter Password" [handleChange]="handleChange">
            <div slot="right" class="icon-container">
              <dsy-icon library="material" name={{inputName}} size="16px " density="default" elevation="auto" material-weight="400" material-grade="0" 
              (click)="inputType()" class="iconVisibility"></dsy-icon>
              </div>
          </dsy-input-with-message>
          <p class="error" *ngIf="passwordValue && !correctPass">Password is not correct</p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer-container">
    <dsy-button size="large" variant="primary" label="dsy-button" button-style="" type="misc" [disabled]="requirePassword && !correctPass" (click)="applyModal()">
      Confirm
    </dsy-button>
    <dsy-button size="large" variant="tertiary" label="dsy-button" button-style="" type="misc" (click)="handleOpenClose($event.target)">
      Cancel
    </dsy-button>
  </div>
</dsy-modal>
